import { PParams } from '@cian/postview-analytics-utils';

import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { BannerInFilter } from 'shared/components/BannerInFilter';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/adBannerMicrofrontend';
import { AdBannerMicrofrontendAdditionalFiltersContainer } from 'shared/containers/AdBannerMicrofrontendAdditionalFiltersContainer';
import { selectBannerPuids } from 'shared/selectors/adfox';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { TAdfoxContextData } from 'shared/types/adfox';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AdfoxBannerContainer } from '../../../../../../../packages/Adfox';
import { FOfferType } from '../../../../../../../packages/JsonQuery';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextData['postViewAnalyticsData'] = {
  place: 'additional_filters',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_filter_more',
};
const P_PARAMS: PParams = { p1: 'crzye', p2: 'fmsa' };
const SIZE: TAdfoxContextData['size'] = { width: '100%', height: 100 };

export const PikBannerInFiltersContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const bannerPuids = useSelector(selectBannerPuids);
  const offerType = useSelector(selectOfferType);

  const [isHidden, setHidden] = useState(false);

  const params = useMemo(() => ({ ...bannerPuids, ...P_PARAMS }), [bannerPuids]);

  const handleHide = useCallback(() => setHidden(true), []);

  const adBannerMicrofrontendManifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  if (offerType !== FOfferType.FlatNew || isHidden) {
    return null;
  }

  return (
    <BannerInFilter>
      {adBannerMicrofrontendManifest ? (
        <AdBannerMicrofrontendAdditionalFiltersContainer
          manifest={adBannerMicrofrontendManifest}
          onStub={handleHide}
          onError={handleHide}
        />
      ) : (
        <AdfoxBannerContainer params={params} size={SIZE} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} />
      )}
    </BannerInFilter>
  );
};
